import { Component, ViewChild } from '@angular/core';
import { LLMConfigurationListComponent } from '../llm-configuration-list/llm-configuration-list.component';
import { LLMConfigurationFormComponent } from '../llm-configuration-form/llm-configuration-form.component';
import { LLMConfigurationToolbarComponent } from '../llm-configuration-toolbar/llm-configuration-toolbar.component';

@Component({
    selector: 'ca-llm-configuration-main',
    templateUrl: './llm-configuration-main.component.html',
    styleUrl: './llm-configuration-main.component.scss',
    standalone: false
})
export class LLMConfigurationMainComponent {
  showForm: boolean = false;

  @ViewChild('list', { static: true, read: LLMConfigurationListComponent })
  list: LLMConfigurationListComponent;

  @ViewChild('form', { static: true, read: LLMConfigurationFormComponent })
  form: LLMConfigurationFormComponent;

  @ViewChild('toolbar', { static: true, read: LLMConfigurationToolbarComponent })
  toolbar: LLMConfigurationToolbarComponent;

  toggleFormVisibility(): void {
    this.showForm = !this.showForm;
  }

  ngOnInit(): void {
    this.list.load([], [], false);
  }

  openNewForm(): void {
    this.form.load(null);
    this.toggleFormVisibility();
  }

  onOpenDetails(eventArgs: { id: number }) {
    this.form.load(eventArgs.id);
    this.toggleFormVisibility();
  }

  onFormSaved() {
    this.toggleFormVisibility();
    this.list.load([], [], false);
  }

  onFormClosed() {
    this.toggleFormVisibility();
  }

  onFormDeleted() {
    this.toggleFormVisibility();
    this.list.load([], [], false);
  }
}
